import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formattedDistance',
    standalone: false,
})
export class FormattedDistancePipe implements PipeTransform {
    transform(distanceM: number): string {
        if (distanceM == null || isNaN(distanceM) || distanceM <= 0) {
            return '0 m';
        }

        const formatter = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 });

        if (distanceM < 1000) {
            return `${formatter.format(distanceM)} m`;
        }
        const km = distanceM / 1000;
        return `${formatter.format(km)} km`;
    }
}
